<div *ngIf="mostrar" class="dialog-overlay" (click)="fecharDialog()">
    <div class="dialog-sem-dados" (click)="$event.stopPropagation()">
        <button class="btn-fechar" (click)="fecharDialog()" aria-label="Fechar">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <div class="conteudo-informacoes">
            <div class="row p-0 m-0 cabecalho-informacoes">
                <div class="col-md-8 p-0">
                    <p>Equipamento sem dados</p>
                    <h3>{{ equipamento?.vc_frota }}</h3>
                    <h4>
                        {{ equipamento?.en_tipo | Capitalize }}
                        <span *ngIf="equipamento?.operador_atual"> - {{ equipamento?.operador_atual?.vc_nome }}</span>
                    </h4>
                </div>
                <div class="col-md-4 p-0 text-end">
                    <img [src]="'assets/mapa/equipamentos/' + equipamento?.en_tipo + '.png'" class="imagem-trator"
                        alt="equipamento" />
                </div>
            </div>
            <hr />
            <div class="mensagem-sem-dados">
                <div class="icone-alerta">
                    <img src="assets/equipamentos/icone-aviso.svg" alt="Ícone de aviso" width="48" height="48">
                </div>
                <h4>Não há dados disponíveis</h4>
                <p>O equipamento não está transmitindo informações no momento.</p>
                <p class="texto-secundario">Verifique a conexão do equipamento ou tente novamente mais tarde.</p>
            </div>
        </div>
    </div>
</div>